import React, { Component } from 'react';

import { Button } from 'components/button';
import { ROUTES } from 'configs/routes/constants';
import Settings from 'configs/Settings';
import Cookie from 'js-cookie';
import { AuthService } from 'modules/auth';
import { Cookies } from 'modules/auth/constants';
import PropTypes from 'prop-types';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: '',
      password: ''
    };
  }

  handleUserChange = (event) => {
    this.setState({ username: event.target.value });
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    if (this.state.username && this.state.password) {
      const userNameEncoded = encodeURIComponent(this.state.username);

      AuthService.loginUser(userNameEncoded, this.state.password).then(() => {
        const token = localStorage.getItem('token');
        const routeToRedirect = AuthService.hasDashboardEnabled
          ? ROUTES.DASHBOARD
          : ROUTES.CONTENT.LIST;

        Cookie.set(Cookies.UserToken, token, Settings.cookieConfig);
        window.location.href = routeToRedirect;
      });
    }
  };

  render() {
    return (
      <div className="grid grid__block card__content">
        <form onSubmit={this.handleSubmit}>
          <div className="input__group">
            <label htmlFor="input-username">{'UserManager'}</label>
            <input
              className="form-control paper-input"
              data-test="username"
              id="input-username"
              onChange={this.handleUserChange}
              required
              type="text"
              value={this.state.username}
            />
          </div>
          <div className="input__group">
            <label htmlFor="input-password">{'Password'}</label>
            <input
              autoComplete="off"
              className="form-control paper-input"
              data-test="password"
              id="input-password"
              onChange={this.handlePasswordChange}
              required
              type="password"
              value={this.state.password}
            />
          </div>
          <div className="input__group">
            <Button
              block
              className="button--submit"
              data-test="submit"
              size="md"
              type="submit"
            >
              {'Login'}
            </Button>
          </div>
        </form>
      </div>
    );
  }
}

Login.propTypes = {
  history: PropTypes.object
};

export default Login;
